export const FEATURE_FLAG_ON = "on";
export const FEATURE_FLAG_OFF = "off";

export const FEATURE_FLAGS = {
  ENABLE_SALARY_DEDUCTIONS_CALCULATOR: "HR_PORTAL_SALARY_DEDUCTIONS_CALCULATOR"
};
